var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeachVolleyball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.0548 39.3347C57.0646 42.6013 52.0203 44.3631 50.5675 44.8246C49.3458 43.7444 45.0408 40.1212 40.175 38.2493C38.2035 37.489 36.3578 37.1063 34.6904 37.1115C33.3952 37.1168 32.1997 37.3527 31.1144 37.8142C30.8836 37.9138 30.6634 38.0186 30.4432 38.1392C30.2125 38.2651 29.987 38.4014 29.7668 38.5482C29.8874 38.1445 30.0185 37.746 30.16 37.3475C30.7945 35.5804 31.644 33.9025 32.6874 32.3505C33.0072 32.1723 33.3375 32.0097 33.6731 31.8629C33.9825 31.7266 34.2971 31.6007 34.6222 31.4906C38.8169 30.0172 44.0446 30.5783 50.2161 33.1685C55.0925 35.2082 59.1667 37.961 61.0544 39.3348L61.0548 39.3347Z",
    fill: "#592EE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0549 34.6837C64.3837 35.9317 63.4451 37.1324 62.2602 38.2702C60.4565 36.9383 56.0991 33.9233 50.8293 31.7106C47.4106 30.274 44.1912 29.4245 41.2653 29.1885C39.6031 29.0522 38.0248 29.1151 36.5462 29.372C36.2316 29.4245 35.9222 29.4874 35.6181 29.5608C35.293 29.6394 34.9731 29.7233 34.6638 29.8177C34.7005 29.7758 34.7424 29.7338 34.7791 29.6919C35.0203 29.4245 35.2772 29.1571 35.5342 28.8949C37.2541 27.175 39.1994 25.7646 41.3072 24.6844C41.9836 24.5323 42.6548 24.4222 43.3154 24.3436C43.9551 24.2702 44.5791 24.2282 45.2031 24.2177C55.3702 24.0604 62.9045 32.1039 65.0551 34.684L65.0549 34.6837Z",
    fill: "#592EE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7625 33.0902C63.4816 30.4999 57.9917 25.0834 50.5358 23.2586C49.9538 23.1171 49.3613 22.9965 48.7583 22.9021C48.15 22.8077 47.526 22.7343 46.8969 22.6923C48.3598 22.3777 49.8699 22.2047 51.3957 22.1785C51.7995 22.1732 52.2085 22.1785 52.607 22.1942C52.6647 22.1942 52.7171 22.1995 52.7748 22.1995C57.6774 22.4144 62.3336 24.1815 66.1194 27.2279C66.1718 27.4953 66.219 27.7575 66.2557 28.0196C66.2924 28.2766 66.3186 28.5335 66.3344 28.7852C66.4392 30.2743 66.2505 31.7162 65.7628 33.09L65.7625 33.0902Z",
    fill: "#592EE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7539 55.2596C31.9007 55.9255 32.0737 56.5862 32.273 57.2416C30.2018 53.9225 29.0063 50.1053 28.8333 46.1358C28.828 46.01 28.8228 45.8789 28.8175 45.7373C28.807 45.4122 28.807 45.0819 28.8123 44.7516C28.8333 43.5456 28.9434 42.3448 29.1479 41.1651C29.3628 40.9186 29.5831 40.6984 29.8138 40.4887C30.0288 40.2947 30.249 40.1164 30.4745 39.9539C31.3449 39.3351 32.3201 38.9418 33.4108 38.774C32.7501 40.3052 31.8168 42.9216 31.3868 46.1935C31.0827 48.5373 31.0775 50.8707 31.3816 53.1464C31.4131 53.3666 31.4445 53.5816 31.476 53.8018C31.5546 54.2947 31.649 54.7771 31.7539 55.2595L31.7539 55.2596Z",
    fill: "#592EE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.526 66.5379C40.6998 65.4526 38.0939 63.8113 35.8706 61.672C35.5717 61.1372 35.2938 60.6024 35.0421 60.057C34.7747 59.496 34.5335 58.9245 34.3133 58.3529C32.8661 54.5724 32.4047 50.5664 32.95 46.4034C33.4324 42.6963 34.6017 39.9016 35.1784 38.6903C36.3582 38.7427 37.6375 39.0154 39.0114 39.4926C38.7545 41.16 38.2459 45.2499 38.5552 50.1679C38.765 53.5184 39.326 56.6435 40.207 59.4645C40.8362 61.4622 41.6279 63.3132 42.5822 65.0016C42.729 65.2637 42.8863 65.5259 43.0436 65.7828C43.2009 66.0398 43.3582 66.2914 43.526 66.5379L43.526 66.5379Z",
    fill: "#592EE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4286 67.7653C54.469 67.9226 53.4937 68.017 52.5133 68.0485C52.2668 68.0589 52.0151 68.0589 51.7582 68.0589C51.5694 68.0589 51.3807 68.0589 51.1919 68.0537C51.0451 68.0485 50.8878 68.0432 50.7305 68.038C49.1469 67.9698 47.5897 67.7339 46.0744 67.3511C45.8908 67.1256 45.7126 66.8949 45.5343 66.6642C45.3613 66.4335 45.1935 66.1975 45.0257 65.9616C42.1785 61.835 40.5268 56.5024 40.123 50.0742C39.8399 45.6121 40.2541 41.8682 40.5111 40.0912C44.6638 41.9107 48.3448 44.9781 49.4774 45.9691C49.2939 46.6613 48.974 48.0193 48.78 49.7968C48.5283 52.1564 48.4654 55.7272 49.6242 59.3294C50.2849 61.3901 51.2811 63.2725 52.5763 64.9137C53.1216 65.6006 53.7193 66.2507 54.3748 66.8643C54.5426 67.0216 54.7104 67.1736 54.8886 67.3257C55.0669 67.4725 55.2452 67.6193 55.4287 67.7662L55.4286 67.7653Z",
    fill: "#592EE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8068 51.4685C72.7476 55.1652 70.7604 58.5577 67.9761 61.3422C67.714 61.6044 67.4466 61.8613 67.1791 62.1025C66.8803 62.3752 66.5709 62.6426 66.2615 62.8943C64.2952 64.504 62.093 65.7625 59.7177 66.6434C58.9836 66.9161 58.2391 67.1468 57.484 67.3408C57.2952 67.2097 57.1065 67.0786 56.9229 66.937C56.7394 66.8007 56.5664 66.6644 56.3934 66.5228C55.7484 66.0037 55.1507 65.4479 54.6106 64.8554C56.6293 64.2733 60.3207 63.0097 64.1379 60.7078C66.9064 59.0403 69.2817 57.1056 71.2061 54.9557C71.2952 54.8509 71.3896 54.7512 71.4787 54.6464C71.9139 54.143 72.3282 53.6292 72.711 53.0995C73.099 52.5647 73.466 52.0193 73.8069 51.4688L73.8068 51.4685Z",
    fill: "#592EE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3908 36.3509C72.3645 36.7074 72.3121 37.0587 72.2492 37.4153C70.4455 47.221 55.0607 55.7831 50.8612 57.9538C50.0642 54.9336 50.1271 52.0025 50.3421 49.9995C50.5256 48.2796 50.8402 46.9583 51.008 46.3343C51.6739 46.1246 53.0739 45.6526 54.799 44.8871C57.0117 43.9118 60.1998 42.2444 62.8372 39.8744C64.5466 38.3381 65.8417 36.6759 66.6964 34.9246C67.4095 33.4616 67.8185 31.9253 67.9129 30.3418C67.9287 30.0953 67.9339 29.8489 67.9391 29.6025C67.9391 29.3455 67.9339 29.0886 67.9182 28.8317L67.9811 28.8946C69.8163 30.7298 71.3107 32.8429 72.4223 35.1343C72.4327 35.5433 72.4223 35.947 72.3908 36.3508L72.3908 36.3509Z",
    fill: "#592EE5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.687 45.6687V45.7159C74.4983 46.3399 74.2833 46.9481 74.0421 47.5354C73.8061 48.1174 73.544 48.6785 73.2661 49.2186C68.1799 59.0607 56.419 62.7463 53.509 63.5229C52.6071 62.3012 51.8783 60.9432 51.3434 59.475C53.5247 58.3633 58.6842 55.5686 63.571 51.6623C66.7486 49.1244 69.2445 46.5657 70.98 44.054C71.8871 42.7484 72.5844 41.448 73.0878 40.1634C73.2032 39.8645 73.308 39.5656 73.4024 39.2667C73.5073 38.9469 73.5964 38.6218 73.6698 38.302C74.2466 40.1634 74.5874 42.1035 74.6766 44.0908C74.6818 44.1694 74.6818 44.2481 74.6871 44.332C74.6975 44.7829 74.6975 45.2338 74.6871 45.669L74.687 45.6687Z",
    fill: "#592EE5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6471,
    cy: 76.0882,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.1176,
    cy: 76.0882,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.0588,
    cy: 76.0882,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5882,
    cy: 76.0882,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.5294,
    cy: 76.0882,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.2353,
    cy: 80.6765,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.7059,
    cy: 80.6765,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.6471,
    cy: 80.6765,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.1765,
    cy: 80.6765,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.1176,
    cy: 80.6765,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.3823,
    cy: 76.0882,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.8529,
    cy: 76.0882,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.7941,
    cy: 76.0882,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.3235,
    cy: 76.0882,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.2647,
    cy: 76.0882,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.9706,
    cy: 80.6765,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.4412,
    cy: 80.6765,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.3823,
    cy: 80.6765,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.9118,
    cy: 80.6765,
    r: 1.14706,
    fill: "#592EE5"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.8529,
    cy: 80.6765,
    r: 1.14706,
    fill: "#592EE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeachVolleyball);
export default __webpack_public_path__ + "static/media/BeachVolleyball.32a41d903b9b05216f0ee488ce5d0bf5.svg";
export { ForwardRef as ReactComponent };